// extracted by mini-css-extract-plugin
export default {"cover":"Banner_cover__CqrLe"};